export const EXAM_LEVEL_SELECT_POPOVER_LIST_HEIGHT = 360;
